import React from "react";
import { CustomComponentCustomFormField, CustomFormSegmentReportData } from "../../../../../amorg-common";
import { Card } from "../../../../../designSystem/Card";
import { H2 } from "../../../../../designSystem/typography/Heading";
import { CustomFormReportBar } from "../DiscreteValueReportField";
type RiskAssessmentReportFieldProps = {
    field:CustomComponentCustomFormField,
    segmentReports:CustomFormSegmentReportData[]
}
export function RiskAssessmentReportField(props:RiskAssessmentReportFieldProps):JSX.Element
{
    const selections:{value:string, count:number}[] = [];
    for(const segmentReport of props.segmentReports)
    {
        const fieldSelections = segmentReport.dataSelections.find(s => s.fieldId === props.field.fieldId);
        if(fieldSelections)
        {
            for(const fs of fieldSelections.selection)
            {
                // catches type===Suggester
                const value = fs.value || '[ingen værdi]';

                let valueCounter = selections.find(s => s.value === value);
                if(!valueCounter)
                {
                    valueCounter = { value, count:0 };
                    selections.push(valueCounter);
                }
                valueCounter.count += fs.count;
            }
        }
    }

    const countSum = selections.reduce((acc, s) => acc + s.count, 0);

    return (
        <Card variant="outlined">
        <H2>{props.field.label}</H2>
        {selections.map((s) => {

            const pct = s.count / countSum * 100;

            return (
                <CustomFormReportBar key={props.field.fieldId + "_" + s.value}
                    pct={pct}
                    text={ `${s.value} (${s.count})`}
                />
            );
        })}
        </Card>
    );
}